import { Link } from '@/components/atoms/Link';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { EVMonoIcon } from '../../icons';

interface FooterProps {
  overlayOpen: boolean;
  onClickDisclaimerPrompt: () => void;
}

const Footer: React.FC<FooterProps> = ({
  overlayOpen,
  onClickDisclaimerPrompt,
}) => {
  return (
    <div
      className={clsx(
        'flex flex-col items-center gap-s border-t border-neutral-200 bg-neutral-100 s:flex-row s:px-l ml:px-3xl',
        {
          'pb-s pt-[7px] s:justify-center': overlayOpen,
          'pb-m pt-[9px] s:justify-between s:pb-s s:pt-[7px]': !overlayOpen,
        }
      )}
    >
      <div
        role="button"
        onClick={onClickDisclaimerPrompt}
        className={clsx('items-center gap-xs', {
          hidden: overlayOpen,
          flex: !overlayOpen,
        })}
      >
        <div className="text-microNormal text-neutral-800">
          *View disclaimer and calculations
        </div>
        <InformationCircleIcon className="size-l stroke-neutral-800" />
      </div>
      <Link href="https://ev.com" target="_blank">
        <div className="flex items-center gap-xs">
          <div className="text-microNormal text-neutral-600">Powered by</div>
          <EVMonoIcon />
        </div>
      </Link>
    </div>
  );
};

export default Footer;
